import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts.css';
import './styles/variables.css';
import './styles/reset.css';
import './styles/animations.css';
import './styles/base.css';
import './styles/layout.css';
import App from './App';

// Регистрация Service Worker для поддержки фонового воспроизведения
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((registration) => {
        // Обновляем Service Worker, если доступна новая версия
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Новая версия доступна, перезагружаем страницу
                window.location.reload();
              }
            });
          }
        });
      })
      .catch((error) => {
        console.warn('[ServiceWorker] Registration failed:', error);
      });
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
// Отключаем StrictMode в продакшене для оптимизации производительности
const AppComponent = process.env.NODE_ENV === 'development' ? (
  <React.StrictMode>
    <App />
  </React.StrictMode>
) : (
  <App />
);
root.render(AppComponent);
